/**
 * Секция погашений
 */

import React from 'react';
import { Formik, Form } from 'formik';
import {
  useLastRepaymentDate,
  usePayOffDebts,
  useUploadPayments,
  useUploadDirectReceipts,
} from '../../../hooks/useAdmin';
import { CreatePaymentFormComponent } from '../forms/CreatePaymentForm';
import { DirectReceiptFormComponent } from '../forms/DirectReceiptForm';
import { FileUploadFormComponent } from '../forms/FileUploadForm';

interface RepaymentsSectionProps {
  creditContractId: number | null;
  selectedClientName: string;
}

/**
 * Компонент секции "Погашения"
 */
export const RepaymentsSection: React.FC<RepaymentsSectionProps> = ({
  creditContractId,
  selectedClientName,
}) => {
  const { data: lastRepaymentDate } = useLastRepaymentDate();
  const payOffDebtsMutation = usePayOffDebts();
  const uploadPaymentsMutation = useUploadPayments();
  const uploadDirectReceiptsMutation = useUploadDirectReceipts();

  const handlePayOffDebts = async () => {
    await payOffDebtsMutation.mutateAsync();
  };

  return (
    <div>
      {/* Плановое погашение всех сделок */}
      <fieldset>
        <Formik initialValues={{}} onSubmit={handlePayOffDebts}>
          {() => (
            <Form>
              <div style={{ display: 'table' }}>
                <div style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                  Плановое погашение всех сделок
                </div>
                <div style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                  {lastRepaymentDate
                    ? `Дата последнего запуска - ${lastRepaymentDate}`
                    : 'Дата последнего запуска не найдена'}
                </div>
                <button
                  className="btn"
                  type="submit"
                  disabled={payOffDebtsMutation.isPending}
                  style={{ marginTop: '20px' }}
                >
                  {payOffDebtsMutation.isPending
                    ? 'Запуск...'
                    : 'Запустить процедуру погашения для всех сделок'}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </fieldset>

      {/* Точечное погашение */}
      <CreatePaymentFormComponent
        creditContractId={creditContractId}
        selectedClientName={selectedClientName}
      />

      {/* Погашение через р/с МКК */}
      <DirectReceiptFormComponent
        creditContractId={creditContractId}
        selectedClientName={selectedClientName}
      />

      {/* Множественное точечное погашение из файла */}
      <FileUploadFormComponent
        title="Множественное точечное погашение из файла"
        fileId="payments"
        onSubmit={async (formData) => {
          await uploadPaymentsMutation.mutateAsync(formData);
        }}
        isLoading={uploadPaymentsMutation.isPending}
      />

      {/* Множественное точечное погашение из файла через Р/С МКК */}
      <FileUploadFormComponent
        title="Множественное точечное погашение из файла через Р/С МКК по займам"
        fileId="paymentsRs"
        onSubmit={async (formData) => {
          await uploadDirectReceiptsMutation.mutateAsync(formData);
        }}
        isLoading={uploadDirectReceiptsMutation.isPending}
      />
    </div>
  );
};
